var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadGrayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "UI_icon_document_filled",
    "data-name": "UI icon/document/filled",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    d: "M20,28H4a4.108,4.108,0,0,1-4-4.2V4.2A4.108,4.108,0,0,1,4,0H16.343a3.883,3.883,0,0,1,2.829,1.23L22.829,5.07A4.282,4.282,0,0,1,24,8.04V23.8A4.108,4.108,0,0,1,20,28ZM6.666,16.8a1.4,1.4,0,0,0,0,2.8H12a1.4,1.4,0,0,0,0-2.8Zm0-5.6a1.4,1.4,0,0,0,0,2.8H17.333a1.4,1.4,0,0,0,0-2.8ZM16.672,2.388a.67.67,0,0,0-.464.192A.7.7,0,0,0,16,3.09V5.6a2.739,2.739,0,0,0,2.667,2.8h2.39a.658.658,0,0,0,.608-.412.712.712,0,0,0-.136-.783L17.138,2.595a.641.641,0,0,0-.466-.206Z",
    fill: "#92979c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadGrayIcon);
export default __webpack_public_path__ + "static/media/uploadGrayIcon.bc348c59aba36f16f7cc789ce7e6712f.svg";
export { ForwardRef as ReactComponent };